import { render, staticRenderFns } from "./AuditStatusTag.vue?vue&type=template&id=e141f43c&scoped=true&"
import script from "./AuditStatusTag.vue?vue&type=script&lang=ts&"
export * from "./AuditStatusTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e141f43c",
  null
  
)

export default component.exports